/*
 * @Author: hfxie
 * @Date: 2021-12-14 14:37:30
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-03-13 16:56:40
 * @Description: 常量:交互自定义事件接口
 */

const RESET_STATUS = "gtRestData"; // 重置·解决苍穹按钮多次同功能请求无效情况
const CUSTOM_INIT = "custom_init"; // 初始化·主动发起数据加载

const SELECT_ROW = "selectNodeGtTreeList"; // 选中行
const SELECT_ROW_ONE = "selectNodeGtTreeListOne"; // 选中态·仅当前行
const CHANGE_EXPAND_STATUS = "expandNodeGtTreeList"; // 修改分组行折叠状态
const ADD_CROSSLINE = "crossline"; // 新增横道连线
const START_PRINT = "sendPrintInfo"; // 打印
const COPY_ROW = "copyTask"; // *** 复制WBS单行 ***
const DEL_ROW = "deleteTask"; // *** 删除WBS单行 ***
const UP_ROW = "upTask"; // *** 上移WBS单行 ***
const DOWN_ROW = "downTask"; // *** 下移WBS单行 ***
const DISTRIBUTE_ROW = "distributeTask"; // *** 分配WBS单行 ***
const DRAG_TASK = "dragTask"; // 拖拽横道
const ADJUST_TASK = "adjustTask"; // 单项调整横道起止
const GET_TASK_INFO = "barClickGtList"; // *** 查看横道详情 ***
const UPDATE_GTVIEW_MODE = "changeGtViewMode"; // 设置甘特图整体视图
const START_EDITROW = "editRow"; // 编辑表单行
const UPDATE_TREE_WIDTH = "changeTreeWidth"; // 设置树宽
const UPDATE_WBSHEADERARR_WIDTH = "changeColumnsWidth"; // 设置左侧表格头单列宽
const UPDATE_INITTABLEWIDTH = "changeInitTableWidth"; // 设置左侧表格视口宽
const UPDATE_MIN_FILLCELLSCALE = "changeMinFillCellScale"; // *** 最小填充比例 ***

const UPDATE_TABLEVIEW_WIDTH = "changeWBSLeftWidth"; //  *** TODO设置左侧表格视口宽度 ***
const DROP_INSIDE = "dropInSide"; // 拖拽释放对象在普通横道
const SELECT_TASK = "selectTask"; // 选中横道
const DBLCLICK_TASK = "dblclickBar"; // 双击横道
const LOAD_CONTENT = "loadContent"; // 加载分批内容·加载更多



const OutConst = {
  RESET_STATUS,
  CUSTOM_INIT,

  SELECT_ROW,
  SELECT_ROW_ONE,
  CHANGE_EXPAND_STATUS,
  ADD_CROSSLINE,
  START_PRINT,
  COPY_ROW,
  DEL_ROW,
  UP_ROW,
  DOWN_ROW,
  DISTRIBUTE_ROW,
  DRAG_TASK,
  ADJUST_TASK,
  GET_TASK_INFO,
  UPDATE_GTVIEW_MODE,
  START_EDITROW,
  UPDATE_TREE_WIDTH,
  UPDATE_WBSHEADERARR_WIDTH,
  UPDATE_INITTABLEWIDTH,
  UPDATE_MIN_FILLCELLSCALE,

  UPDATE_TABLEVIEW_WIDTH,
  DROP_INSIDE,
  SELECT_TASK,
  DBLCLICK_TASK,
  LOAD_CONTENT,


};

export default OutConst;
